function refreshCart(t) {
  $.getJSON('/cart.js').then(function(cart) {
    var htm = '';
    cart.items.forEach(function(item, i) {
      var j = i + 1;
      htm += '<div class="row-cart"  data-cart-item data-line-id="'+j+'" data-variant-id="'+item.id+'">';
      if (item && item.featured_image && item.featured_image.url) {
        htm += '<img class="cart-notification-product__image" src="'+item.featured_image.url+'" alt="" width="119" height="123" loading="lazy">';
      } else {
        htm += '<img class="cart-notification-product__image" src="https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif" alt="" width="119" height="123" loading="lazy">';
      }
      htm += '<div class="cart_item_content">';
      htm += '<a href="'+item.url+'">';
      htm += '<h3 class="cart-notification-product__name h4">'+item.product_title+'</h3>';
      htm += '</a>';
      htm += '<dl><div class="product-option">';
      htm += '<dt>'+item.options_with_values[0].name+' </dt>';
      htm += '<dd>'+item.options_with_values[0].value+'</dd>';
      htm += '</div>';
      htm += '<div class="product-option">';
      htm += '<dt>Qty </dt>';

      htm += '<dd>';
      htm += '<div class="left product-quantity-box">';
      htm += '<span class="ss-icon product-minus js-change-quantity" data-func="minus">-</span>';
      htm += '<input type="text" readonly min="0" class="quantity" name="updates[]" id="updates_'+item.id+'" value="'+item.quantity+'" data-cart-quantity-input="mini-cart"/>';
      htm += '<span class="ss-icon product-plus js-change-quantity" data-func="plus">+</span>';
      htm += '</div>';
      htm += '</dd>';

      htm += '</div>';
      htm += '</dl>';
      htm += '</div>';
      htm += '</div>';
    });
    $('#cart-notification-product').html(htm);
    var a = cart.total_price/100;
    a = a.toFixed(2);
    $('.mini-cart-total-price span').text('$'+a+' AUD');
    $('.cart-count-bubble span').html('('+cart.item_count+')');

    if (t == false || t == undefined) {
      $('a#cart-icon-bubble').trigger('click');
      $('.point-to-icon').addClass('animate active');
      $('body').addClass('drawer--open');
      $('.overlay_body').show();
    }

    if (cart.items.length == 0) {
      $('div#cart-notification .cart-notification__links').hide();
      $('.cartempty').show();
    } else {
      $('.cartempty').hide();
      $('div#cart-notification .cart-notification__links').show();
    }
  })
  .fail(function(err){
    console.log(err);
  });
}
$(document).on('click', '.size-box li.available-li', function() {
  $(this).parents('.size-box').find('li').removeClass('active');
  $(this).addClass('active');
  $(this).parents('.size-box').find('input').removeAttr('checked');

  $(this).find('input').attr('checked', true);
  $(this).find('input').prop('checked', true);
}); 
$(document).on('click', 'button.quick-add-elevate', function() {
  $(this).parent().parent('.size-box').find('ul').css('visibility', 'hidden');
  $(this).parent().parent('.size-box').find('ul').siblings('.procard_loaader').show();
  $(this).attr('disabled', 'disabled');
  var that = $(this);
  $.ajax({
    type: 'POST', 
    url: '/cart/add.js',
    dataType: 'json', 
    data: $(this).parent().parent('.size-box').find('form').serialize(),
    success: function(response) {
      refreshCart(false);
      $('.size-box li.available-li').parent('ul').css('visibility', 'visible');
      $('.procard_loaader').hide();
      that.removeAttr('disabled');
    },
    error: function() {
      $('.size-box li.available-li').parent('ul').css('visibility', 'visible');
      $('.procard_loaader').hide();
      that.removeAttr('disabled');
    }
  });
});  

$(document).ready(function() {  

  function updateCartItemQuantity(cartItem) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: {
        quantity: cartItem.quantity,
        line: cartItem.lineID
      },
      success: function (data) {
        refreshCart(true);
      },error: function() {
        refreshCart(true);
      }
    });
  }


  $('body').on('change', '[data-cart-quantity-input]', function() {
    var cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: $(this).val(),
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element : $(this).parents('[data-cart-item]')
    }
    // Disable button after click to prevent multiple clicks
    $(this).parents('.product-quantity-box').find('.js-change-quantity').addClass('is-disabled');
    updateCartItemQuantity(cartItem);
  });

  $('body').on('click', '.js-change-quantity', function() {
    console.log('heree')
    var v = parseInt($(this).siblings('input').val());
    if ($(this).attr('data-func') == 'plus') {
      v = v + 1;
    } else {
      v = v - 1;
    }
    $(this).siblings('input').val(v).change();
  });

  $('summary.header__menu-item').click(function() {
    $('body').toggleClass('side-bar-menu-opened');
    var sticky = $('.template-index header.header');
    sticky.removeClass('fixed');
    $('body.template-index').removeClass('fixed-header');
  });

  // $('svg.closemenubar').click(function() {
  //   $(this).parents('details').find('summary.header__menu-item').trigger('click');
  // });

  //   $("header.header").mouseover(function(){
  //     var sticky = $('.template-index header.header'),
  //         scroll = $(window).scrollTop();

  //     if (scroll <= 100) {
  //       sticky.removeClass('fixed');
  //       $('body.template-index').removeClass('fixed-header');
  //     }
  //   });

  //   $("header.header").mouseleave(function(){
  //     var sticky = $('.template-index header.header'),
  //         scroll = $(window).scrollTop();

  //     if (scroll <= 100) {
  //       sticky.addClass('fixed');
  //       $('body.template-index').addClass('fixed-header');
  //     }
  //   });

});

  function getQueryVariable(url, variable) {
  	 var query = url.substring(1);
     var vars = query.split('&');
     for (var i=0; i<vars.length; i++) {
          var pair = vars[i].split('=');
          if (pair[0] == variable) {
            return pair[1];
          }
     }

     return false;
  }


  $(document).on('click', 'form#FacetSortDrawerForm', function() {
    $('span.mobile-facets__open').trigger('click');
    $('.mobile-facets__main details').hide();
    $('.mobile-facets__main details#product-grid-sort').show();
  });
  $(document).on('click', '.mobile-facets__close', function() {
    $('.mobile-facets__main details').show();
    $('.mobile-facets__main details#product-grid-sort').hide();
  });

  $(document).on('click', '#product-grid-sort li.mobile-facets__item', function(e) {
    e.preventDefault();
    var v = $(this).find('input').val();
    var url = location.href;
    
    url = url.replace('?sort_by=manual' , '?');
    url = url.replace('?sort_by=best-selling' , '?');
    url = url.replace('?sort_by=title-ascending' , '?');
    url = url.replace('?sort_by=title-descending' , '?');
    url = url.replace('?sort_by=price-ascending' , '?');
    url = url.replace('?sort_by=price-descending' , '?');
    url = url.replace('?sort_by=created-ascending' , '?');
    url = url.replace('?sort_by=created-descending' , '?');
    
    var w = getQueryVariable(url, 'sort_by');
    var params = { 'sort_by':v };
    var new_url = '';
    if (url.includes('?')) {
         new_url = url +'&'+ jQuery.param(params);
    } else {
         new_url = url +'?'+ jQuery.param(params);
    }

    location.href = new_url;
  });
$(window).scroll(function(){
  var sticky = $('.template-index header.header'),
      scroll = $(window).scrollTop();

  if (scroll >= 100) {
    sticky.removeClass('fixed');
    $('body.template-index').removeClass('fixed-header');
  } else {
    sticky.addClass('fixed');
    $('body.template-index').addClass('fixed-header');
  }
});

// Product page size guide
$(document).ready(function() {
$('.product__accordion.index8 details summary').trigger('click');

  $('header-menu details:not([open]) summary').mouseenter(function() {
    $(this).trigger('click');
  })

  $('.btn-open').click(function() {
    $('.modal-wrapper').addClass('open')
  });

  $('.btn-close').click(function() {
    $('.modal-wrapper').removeClass('open')
  });

  $('.banner-announcement-close').click(function() {
    $(this).parent().hide();
  });


  $('.header__icon.header__icon--cart').click(function(e) {
    e.preventDefault();
    $('#cart-notification').toggleClass('animate active');
    $('.point-to-icon').toggleClass('animate active');
    $('.overlay_body').toggle();
    $('body').toggleClass('drawer--open');
  });

  $('button.cart-notification__close').click(function() {
    $('.point-to-icon').removeClass('active');
    $('.point-to-icon').removeClass('animate');
    $('body').removeClass('drawer--open');
    $('.overlay_body').hide();
  });

  $('button.slider-button').click(function() {
    setTimeout(function() {
      var i = $('.slider-counter--current').html();
      $('span.current_slide').removeClass('active');
      $('span.current_slide.in-'+i).addClass('active');
    }, 400);
  });
  
  $( '.details_wrapper .header__menu-item.mn').mouseover( function() {
    setTimeout(function() {
      if ($('body').hasClass('menuopened') && !($('body').hasClass('already_menuopened'))) {
        $('body').addClass('already_menuopened');
      }      
    }, 266);
    $('body').addClass('menuopened side-bar-menu-opened');
    $('.details_wrapper').removeClass('headermenu_menuopened');
    $(this).parent().addClass('headermenu_menuopened');
    var headerheight = $('header.header').innerHeight();
    $('.headermenu_menuopened .header-submenu-view').css('top', headerheight);
  });
  $(document).on('click','svg.closemenubar', function() {
    $('body').removeClass('menuopened');
    $('body').removeClass('already_menuopened');
    $('body').removeClass('side-bar-menu-opened');
    $('.details_wrapper').removeClass('headermenu_menuopened');
  });
  $(document).on('click','.menuopened .overlaydiv', function() {
    $('svg.closemenubar').trigger('click');
  });
  $('.product__media-gallery .slider-button').html('<img src="https://cdn.shopify.com/s/files/1/0879/3876/files/arrow.svg?v=1661148184" />');
});
